import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * Unified admin search input. Same look across Clients, Invoices,
 * Messages, Bookings, etc. Includes a clear-x button when non-empty.
 */
export const AdminSearch = ({
  value,
  onChange,
  placeholder = 'Search...',
  testid,
  className = '',
  autoFocus = false,
}) => (
  <div className={`relative w-full ${className}`}>
    <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none" />
    <input
      data-testid={testid}
      value={value || ''}
      autoFocus={autoFocus}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      className="w-full pl-9 pr-9 py-2.5 rounded-xl border border-white/10 bg-black/30 text-white placeholder-white/40 focus:border-[var(--pg-admin-accent)] focus:ring-2 focus:ring-[var(--pg-admin-accent-ring)] outline-none transition-colors"
    />
    {value ? (
      <button
        type="button"
        aria-label="Clear search"
        onClick={() => onChange?.('')}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 inline-flex items-center justify-center rounded-lg text-white/40 hover:text-white hover:bg-white/5"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    ) : null}
  </div>
);

export default AdminSearch;
